<script>
    import R, {LOADER} from "../lib/requests";
    import {ROUTE_TYPES, TRANSFER_STATUSES} from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';

    export let transfers;

    let totalNotified = 0;

    const getTotalNotified = () => {
        totalNotified = transfers && transfers.length > 0 ? transfers.filter(x => x.is_notified).length : 0;
    }

    const sendNextNotification = () => {
        const onSuccess = result => {
            transfer.is_notified = true;
            transfers = transfers;
            sendNextNotification();
        };

        const onFailure = err => {
            transfer.is_notified = true;
            transfers = transfers;
            sendNextNotification();
        };

        getTotalNotified();
        if (totalNotified == transfers.length) {
            return;
        }

        let transfer = null;
        transfers.map(item => {
            if (!item.is_notified) {
                transfer = item;
            }
        });

        if (transfer) {
            R.handle(R.transfer.send_notification_email, {id: transfer.id}, onSuccess, onFailure, LOADER.POPUP);
        }
    }

    const close = () => {
        transfers = null;
    }

    getTotalNotified();
</script>

{#if transfers}
    <Modal modalSm title="Send notification mails" on:close={close}>
        <div slot="body">
            <p>
                There are {transfers.length} transfers to be notified about their departure or arrival.
            </p>
            <ul class="list-group mb-4">
                {#each transfers as transfer}
                    <li class="list-group-item">
                        <div>
                            {ROUTE_TYPES[transfer.route_type]}
                            <span class="text-gray">({TRANSFER_STATUSES[transfer.status_id]})</span>
                        </div>
                        <div class="d-flex justify-content-between gap-2 border-bottom-dotted pb-1 mb-1">
                            <div class="fw-semibold">
                                {transfer.pickup_name} → {transfer.drop_name}
                            </div>
                            <div>
                                {formatDate(transfer.transfer_at, 'd-m-y H:i')}
                            </div>
                        </div>
                        <div>
                            {transfer.customer.fullname}<br>
                            <span class="text-gray">{transfer.customer.email}</span>
                        </div>
                    </li>
                {/each}
            </ul>
            {#if totalNotified == transfers.length}
                <div class="alert alert-info">
                    A notification has been sent for all transfers.
                </div>
            {/if}
            <div class="text-end">
                {#if totalNotified == transfers.length}
                    <button class="btn btn-primary px-4" on:click={close}>Close</button>
                {:else}
                    <button class="btn btn-link me-2" on:click={close}>Not now</button>
                    <button class="btn btn-primary px-4" on:click={sendNextNotification}>Send mails</button>
                {/if}
            </div>
        </div>
    </Modal>
{/if}
